import { c as _c } from "react/compiler-runtime";
import { LayoutContainer } from '@petsmart-ui/sparky';
import type { DropdownNavigationItem } from '../../../../types';
import { PanelBody } from './panel-body';
import { SidebarPanel } from './sidebar-panel';
type DropdownPanelProps = {
  item: DropdownNavigationItem;
};
export function DropdownPanel(t0) {
  const $ = _c(7);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.title) {
    t1 = [item.title];
    $[0] = item.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectionPath = t1;
  let t2;
  if ($[2] !== item.kind || $[3] !== item.panel || $[4] !== item.sidebarItems || $[5] !== selectionPath) {
    t2 = <LayoutContainer className="dropdown-panel sparky-u-width-100">{item.kind === "sidebar" ? <SidebarPanel items={item.sidebarItems} selectionPath={selectionPath} /> : <PanelBody panel={item.panel} selectionPath={selectionPath} />}</LayoutContainer>;
    $[2] = item.kind;
    $[3] = item.panel;
    $[4] = item.sidebarItems;
    $[5] = selectionPath;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}